module.exports = __webpack_public_path__ + "static/media/1026001.478ef7cd.jpg";